import React, { Suspense, useDeferredValue } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { NodeContainerLoading } from "../system/NodeContainerLoading";

function SuspenseWrapper() {
  const location = useLocation();
  const deferredLocation = useDeferredValue(location);
  const isTransitioning = location.pathname !== deferredLocation.pathname;

  return (
    <Suspense fallback={<NodeContainerLoading />}>
      {isTransitioning ? (
        <NodeContainerLoading />
      ) : (
        <Outlet key={deferredLocation.pathname} />
      )}
    </Suspense>
  );
}
export default SuspenseWrapper;